const toDataURL = (url) => {
    return fetch(url)
        .then(response => response.blob())
        .then(blob => URL.createObjectURL(blob));
};
export const downloadFile = async (src, name) => {
    try {
        const a = document.createElement('a');
        a.href = await toDataURL(src);
        a.download = name || '';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    catch (e) {
        window.open(src, '_blank').focus();
        console.error('Error while downloading file', e.message);
    }
};
//# sourceMappingURL=utils.js.map